export default __webpack_public_path__ + "390a57713318e01c557523097adb80b6.svg";